import { gqlTagGira } from '@atlassian/jira-issue-fetch-services-common/src/services/issue-gira-data/gira-fragments/index.tsx';
import { getClient } from '@atlassian/jira-issue-fetch-services/src/common/utils/client.tsx';
import {
	toErrorId,
	toErrorMessage,
} from '@atlassian/jira-project-settings-apps-common/src/types.tsx';
import { famaCatchAndLogFetchError } from '@atlassian/jira-project-settings-apps-common/src/util/catch-and-log-fetch-error.tsx';
import { toBaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import { PACKAGE_NAME } from '../../constants.tsx';
import type { GraphqlResponse } from '../types.tsx';
import type { IssueTypeNames } from './__generated_apollo__/IssueTypeNames';

const issueTypeNamesQuery = gqlTagGira`
query IssueTypeNames($projectId: Long!) {
  simplifiedProject(projectId: $projectId) {
    issueTypes {
      id
      name
    }
  }
}
`;

export type IssueType = {
	readonly id: number;
	readonly name: string;
};

export const fetchIssueTypeNames = (projectId: number): Promise<ReadonlyArray<IssueType>> => {
	const client = getClient(toBaseUrl('')); // in cloud, baseUrl is always empty string

	return famaCatchAndLogFetchError<GraphqlResponse<IssueTypeNames>>(
		client.query({ query: issueTypeNamesQuery, variables: { projectId } }),
		PACKAGE_NAME,
		toErrorId('fetchEverything'),
		toErrorMessage('Failed to fetch data for every issue type on the issue type page'),
	).then(({ data }: GraphqlResponse<IssueTypeNames>) => {
		if (!data || !data.simplifiedProject || !data.simplifiedProject.issueTypes) {
			throw new Error('Failed to fetch issue type names');
		}

		return data.simplifiedProject.issueTypes.filter(Boolean);
	});
};
